import { render, staticRenderFns } from "./Deployments.vue?vue&type=template&id=5390c4b6&scoped=true"
import script from "./Deployments.vue?vue&type=script&lang=js"
export * from "./Deployments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390c4b6",
  null
  
)

export default component.exports